<div class="float-end flex gap-1 me-3 mt-2">
    <button title="Save Changes"><i class="pi pi-save text-green-600" style="font-size: 1.5rem"></i></button>
    <p-divider layout="vertical" />
    <button title="Delete"><i class="pi pi-trash text-lrpTicketRed" style="font-size: 1.5rem"></i></button>
</div>